<template>
  <layout title="Join session">
    <div class="row">
      <div class="col-md-12">
        <div class="card shadow-sm p-3 mb-5 bg-white rounded mt-2">
          <div class="card-body col-md-12">
            <div class="row">
              <div class="col-10">
                <h2 class="page-heading">
                  <inertia-link
                    class="previous-path-header"
                    :href="route('classrooms.assigned')"
                  >
                    Classrooms
                  </inertia-link>
                  /
                  <inertia-link
                    class="previous-path-header"
                    :href="
                      route(
                        'classrooms.assigned.view.sessions',
                        classroom.data.id
                      )
                    "
                  >
                    {{ classroom.data.name }}
                  </inertia-link>

                  / {{ session.start_datetime }}
                </h2>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 text-center">

                <div v-if="sessionRequest && sessionRequest.status == 'REJECTED'" class="alert alert-danger">
                  Your current request is REJECTED
                </div>
                
                <div
                  role="status"
                  class="spinner-border text-secondary mt-5 mb-5"
                  style="height: 3rem; width: 3rem"
                >
                  <span class="sr-only">Loading...</span>
                </div>

                <h4 class="mt-3">
                  Your request has been sent and awaiting acceptance
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";

export default {
  layout: [AppLayout],
  props: {
    classroom: Object,
    session: Object,
    flash: Object,
    sessionRequest: Object,
    csrf_token: String
  },
  data() {},
  methods: {},
  mounted() {
    this.requests = this.session_requests;

    Echo.setCsrf(this.csrf_token)
    Echo.private(`session-request-accepted-${this.sessionRequest.id}`).listen(
      "SessionRequestUpdated",
      (e) => {
        this.$inertia.get(
          route("classrooms.assigned.sessions.join", [
            this.classroom.data.id,
            this.session.id,
          ])
        );
      }
    );
  },
  unmounted() {
    Echo.leave(`session-request-accepted-${this.sessionRequest.id}`);
  },
};
</script>